// extracted by mini-css-extract-plugin
module.exports = {"fullscreen":"NotAdminPage_fullscreen__hjT8Y","icon":"NotAdminPage_icon__ar_IM","errorTitle":"NotAdminPage_errorTitle__1cqvN","errorText":"NotAdminPage_errorText__Ujc2M"};